<template>
	<div class="resource-booking-modal-allocation-type-selection">
		<strong class="resource-booking-modal-allocation-type-selection__text">
			{{ $t('resource-booking-modal__allocation_type') }}:
		</strong>
		<SuiIcon
			v-tooltip="$t('resource-booking-modal__allocation_type_tooltip')"
			name="icon-info-16"
		/>
		<div
			class="resource-booking-modal-allocation-type-selection__radio-group"
		>
			<SuiRadioGroup
				v-model="modelValue"
				:items="allocationTypeItems"
				name="allocation-type"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useTranslation } from '@/composables';
import {
	SuiIcon,
	SuiRadioGroup,
	type SuiRadioGroupItem,
} from '@developers/scoro-ui';
import { BOOKING_ALLOCATION_TYPE } from '../../constants';
import { type BookingAllocationType } from '../../types';

export type ResourcePlanningBookingModalAllocationTypeSelectionProps = {
	isFixedBookingDisabled: boolean;
};

const props =
	defineProps<ResourcePlanningBookingModalAllocationTypeSelectionProps>();

const modelValue = defineModel<BookingAllocationType>({ required: true });

const { t } = useTranslation();

const allocationTypeItems = computed<SuiRadioGroupItem[]>(() => [
	{
		label: t('resource-booking-modal__fixed_allocation_type'),
		id: BOOKING_ALLOCATION_TYPE.FIXED,
		value: BOOKING_ALLOCATION_TYPE.FIXED,
		disabled: props.isFixedBookingDisabled,
		tooltip: props.isFixedBookingDisabled
			? t('resource_planning_booking_modal_placeholder_fixed_disabled')
			: undefined,
	},
	{
		label: t('resource-booking-modal__tentative_allocation_type'),
		id: BOOKING_ALLOCATION_TYPE.TENTATIVE,
		value: BOOKING_ALLOCATION_TYPE.TENTATIVE,
	},
]);
</script>

<style lang="scss" scoped>
.resource-booking-modal-allocation-type-selection {
	display: flex;
	gap: 0.5rem;

	&__text {
		font-weight: $scoro-fw-semi-bold;
	}

	&__radio-group {
		margin-left: 1.5rem;
	}
}
</style>
